export default __webpack_public_path__ + "static/media/image2.535e1efb.png";